
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/facilities/[id]",
      function () {
        return require("private-next-pages/facilities/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/facilities/[id]"])
      });
    }
  